import PaymentComponent from "./components/payment_component";
import { PaymentStateContextProvider } from "./state/payment_state";

export default function PaymentPage() {
  return (
    <PaymentStateContextProvider>
      <PaymentComponent />
    </PaymentStateContextProvider>
  );
}
